import React from "react";

import {
    PhoneVerificationFormComponent,
    Props as PhoneVerificationFormComponentProps,
    PhoneVerificationFormData,
} from "@/mk2/apps/users/containers/PhoneVerification/PhoneVerificationForm";
import { mkReduxForm } from "@/mk2/decorators/mkReduxForm";

export const PASSWORD_RESET_PHONE_FORM_NAME = "PASSWORD_RESET_PHONE_FORM";

type Props = PhoneVerificationFormComponentProps;

export type PasswordResetPhoneFormData = PhoneVerificationFormData;

export const PasswordResetPhoneForm = mkReduxForm<PasswordResetPhoneFormData, Props>({
    formName: PASSWORD_RESET_PHONE_FORM_NAME,
    onValidate: () => ({
        /* nothing to do, validation on server side */
    }),
    onSave: (values, props) => props.onValidateToken(values.token, values.fullPhoneNumber),
    disableDirtyCheck: true,
})(PhoneVerificationFormComponent);
